import { render, staticRenderFns } from "./regproduct.vue?vue&type=template&id=39187bef"
import script from "./regproduct.vue?vue&type=script&lang=js"
export * from "./regproduct.vue?vue&type=script&lang=js"
import style0 from "./regproduct.vue?vue&type=style&index=0&id=39187bef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports